import {
  exportResumenDetalle347,
  exportResumenDetalleIva111,
  exportResumenDetalleIva115,
  exportResumenDetalleIva180,
  exportResumenDetalleIva190,
  exportResumenDetalleIva303,
  exportResumenDetalleIva349,
  exportResumenDetalleIva390,
  getResumenDetalleIva111,
  getResumenDetalleIva115,
  getResumenDetalleIva180,
  getResumenDetalleIva190,
  getResumenDetalleIva303,
  getResumenDetalleIva347,
  getResumenDetalleIva349,
  getResumenDetalleIva390,
} from "api/AsientoContable.service"
import { TFunction } from "i18next"
import { MODELO_IMPUESTO } from "../../../../../api/Types/ModeloImpuesto"

export const MODELOS_IMPUESTOS = (t?: TFunction) => {
  return {
    [MODELO_IMPUESTO.MODELO_111]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#0067B1]",
      detailTitle: t && t("taxSummary.detail.title111"),
      tabIndex: 0,
      serviceResumenDetalle: getResumenDetalleIva111,
      serviceExportResumenDetalle: exportResumenDetalleIva111,
    },

    [MODELO_IMPUESTO.MODELO_115]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#6BCFD9]",
      detailTitle: t && t("taxSummary.detail.title115"),
      tabIndex: 1,
      serviceResumenDetalle: getResumenDetalleIva115,
      serviceExportResumenDetalle: exportResumenDetalleIva115,
    },

    [MODELO_IMPUESTO.MODELO_180]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#85A3CE]",
      detailTitle: t && t("taxSummary.detail.title180"),
      tabIndex: 2,
      serviceResumenDetalle: getResumenDetalleIva180,
      serviceExportResumenDetalle: exportResumenDetalleIva180,
    },

    [MODELO_IMPUESTO.MODELO_190]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#85A3CE]",
      detailTitle: t && t("taxSummary.detail.title190"),
      tabIndex: 3,
      serviceResumenDetalle: getResumenDetalleIva190,
      serviceExportResumenDetalle: exportResumenDetalleIva190,
    },

    [MODELO_IMPUESTO.MODELO_303]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#B7CB8C]",
      detailTitle: t && t("taxSummary.detail.title303"),
      tabIndex: 4,
      serviceResumenDetalle: getResumenDetalleIva303,
      serviceExportResumenDetalle: exportResumenDetalleIva303,
    },

    [MODELO_IMPUESTO.MODELO_347]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#E8AE0E]",
      detailTitle: t && t("taxSummary.detail.title347"),
      tabIndex: 5,
      serviceResumenDetalle: getResumenDetalleIva347,
      serviceExportResumenDetalle: exportResumenDetalle347,
    },

    [MODELO_IMPUESTO.MODELO_349]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#139144]",
      detailTitle: t && t("taxSummary.detail.title349"),
      tabIndex: 6,
      serviceResumenDetalle: getResumenDetalleIva349,
      serviceExportResumenDetalle: exportResumenDetalleIva349,
    },
    [MODELO_IMPUESTO.MODELO_390]: {
      className:
        "tw-ml-2 tw-rounded tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#799F2E]",
      detailTitle: t && t("taxSummary.detail.title390"),
      tabIndex: 7,
      serviceResumenDetalle: getResumenDetalleIva390,
      serviceExportResumenDetalle: exportResumenDetalleIva390,
    },
  }
}
